import { useEffect, useState } from "react";
import { groupApi } from "../api/group.service";
import { EventType } from "../types";

export const useGetEvents = () => {
  const [data, setData] = useState<EventType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchData = async () => {
    try {
      setLoading(true);

      const response: any = await groupApi.events();

      setData(response?.data?.data ?? []);

      return true;
    } catch (err: any) {
      console.log("Get events failed:", err);

      setError(err.message || "Something wrong");

      return false;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    fetchData,
    loading,
    error,
  };
};
